import { render, staticRenderFns } from "./WorkerRegistrationFormPage.vue?vue&type=template&id=66be3125&"
import script from "./WorkerRegistrationFormPage.vue?vue&type=script&lang=js&"
export * from "./WorkerRegistrationFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports